import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_materials_selector_grid_ComponentContextService } from './FootprintManager.materials_selector_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { InventoryCounts_projects_dd_singleComponent } from './InventoryCounts.projects_dd_single.component'
import { InventoryCounts_material_statuses_dd_singleComponent } from './InventoryCounts.material_statuses_dd_single.component'
import { InventoryCounts_storage_category_rules_dd_singleComponent } from './InventoryCounts.storage_category_rules_dd_single.component'


interface IFootprintManager_materials_selector_gridComponentEntity {
  LookupCode?: string, Id?: number, Description?: string, Status_Id?: number, Status_Name?: string, TemperatureCategoryRule_Id?: number, TemperatureCategoryRule_Name?: string}

interface IFootprintManager_materials_selector_gridComponentInParams {
  selectedMaterialIds?: number[], isExclude?: boolean, allowEdit: boolean}

interface IFootprintManager_materials_selector_gridComponentOutParams {
  selectedMaterialIds?: number[]}

class FootprintManager_materials_selector_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_materials_selector_gridComponent;
  entity: IFootprintManager_materials_selector_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    material_lookupcode: null,
    material_description: null,
    status_name: null,
    temperature_category_rule_name: null,
  }



  constructor(
    grid: FootprintManager_materials_selector_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_materials_selector_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.material_lookupcode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.temperature_category_rule_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.temperature_category_rule_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_materials_selector_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_materials_selector_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      projectId:  $grid.filters.project.control.value ,
      materialIds:  $grid.outParams.selectedMaterialIds ,
      isExclude:  $grid.inParams.isExclude ,
      storageCategoryRuleId:  $grid.filters.storage_category_rules.control.value ,
      statusId:  $grid.filters.status.control.value ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.InventoryCounts.ds_material_selector_batched.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_materials_selector_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.material_lookupcode.displayControl as TextModel).text = $row.entity.LookupCode;
    (this.cells.material_description.displayControl as TextModel).text = $row.entity.Description;
    (this.cells.status_name.displayControl as TextModel).text = $row.entity.Status_Name;
    (this.cells.temperature_category_rule_name.displayControl as TextModel).text = $row.entity.TemperatureCategoryRule_Name;

  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }


}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => InventoryCounts_projects_dd_singleComponent),
    forwardRef(() => InventoryCounts_material_statuses_dd_singleComponent),
    forwardRef(() => InventoryCounts_storage_category_rules_dd_singleComponent),
  ],
  selector: 'FootprintManager-materials_selector_grid',
  templateUrl: './FootprintManager.materials_selector_grid.component.html'
})
export class FootprintManager_materials_selector_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_materials_selector_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_materials_selector_gridComponentInParams = { selectedMaterialIds: [], isExclude: null, allowEdit: null };

  outParams: IFootprintManager_materials_selector_gridComponentOutParams = { selectedMaterialIds: [] };

  //#region Variables
  vars: { hasBeenInitialized?: boolean } = { };
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ selectedMaterialIds?: number[] }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  headers = {
     material_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'material_lookupcode', 'Material', false, false, null, false),       material_description: new GridHeaderModel(new HeaderStyles(null, null), 'material_description', 'Description', false, false, null, false),       status_name: new GridHeaderModel(new HeaderStyles(null, null), 'status_name', 'Status', false, false, null, false),       temperature_category_rule_name: new GridHeaderModel(new HeaderStyles(null, null), 'temperature_category_rule_name', 'Storage category', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_materials_selector_gridComponentRowModel[] = [];

  @Input('selectedMaterialIds') set $inParams_selectedMaterialIds(value: any) {
    this.inParams['selectedMaterialIds'] = value;
  }
  get $inParams_selectedMaterialIds(): any {
    return this.inParams['selectedMaterialIds'] ;
  }
  @Input('isExclude') set $inParams_isExclude(value: any) {
    this.inParams['isExclude'] = value;
  }
  get $inParams_isExclude(): any {
    return this.inParams['isExclude'] ;
  }
  @Input('allowEdit') set $inParams_allowEdit(value: any) {
    this.inParams['allowEdit'] = value;
  }
  get $inParams_allowEdit(): any {
    return this.inParams['allowEdit'] ;
  }

  topToolbar = {
      toggle_add_remove: new ToolModel(new ButtonModel('toggle_add_remove', new ButtonStyles(['creation'], null), false, false, false, 'Toggle add/remove', 'icon-ic_fluent_add_subtract_circle_20_filled', null)
    , false),
      add_dropdown: new ToolModel(new SplitButtonModel<{ add_remove_selected_materials: ButtonModel, add_remove_all_materials: ButtonModel }>(
        'add_dropdown',
        new ButtonStyles(['creation'], null),
        false,
        false,
        'Add',
        'icon-ic_fluent_add_20_regular',
        null,
        [
          new ButtonModel('add_remove_selected_materials', new ButtonStyles(null, null), false, false, false, 'Add selected', ''),
          new ButtonModel('add_remove_all_materials', new ButtonStyles(null, null), false, false, false, 'Add all', '')
        ])
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    storage_category_rules: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Project', false, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Material status', false, false),
    storage_category_rules: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['storage_category_rules'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Storage category', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_materials_selector_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Material selector';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.allowEdit)) {
        this.$missingRequiredInParams.push('allowEdit');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      projectId:  $grid.filters.project.control.value ,
      materialIds:  $grid.outParams.selectedMaterialIds ,
      isExclude:  $grid.inParams.isExclude ,
      storageCategoryRuleId:  $grid.filters.storage_category_rules.control.value ,
      statusId:  $grid.filters.status.control.value ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.InventoryCounts.ds_material_selector_batched.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_materials_selector_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_materials_selector_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_materials_selector_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_materials_selector_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_selector_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length > 0) {
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.readOnly = false;
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = true;
  }
  else {
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.readOnly = true;
      if ($grid.rows.length > 0) {
          $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = false;
      }
  }
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_materials_selector_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_selector_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = true;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.readOnly = true;
  $grid.topToolbar.toggle_add_remove.control.readOnly = true;
  
  // Initialize inputs
  if (!$utils.isDefined($grid.inParams.isExclude)) {
      $grid.inParams.isExclude = false;
  }
  
  // Initialize outputs
  $grid.outParams.selectedMaterialIds = $grid.vars.hasBeenInitialized ? $grid.outParams.selectedMaterialIds : $grid.inParams.selectedMaterialIds ?? [];
  
  // Set button settings
  if ($grid.inParams.isExclude) {
      $grid.title = 'Add Materials';
      $grid.topToolbar.toggle_add_remove.control.label = 'View Selected Materials';
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.label = 'Add All';
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.label = 'Add Selected';
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.icon = "icon-ic_fluent_add_20_regular";
  }
  else {
      $grid.title = 'Selected Materials';
      $grid.topToolbar.toggle_add_remove.control.label = 'Add Materials';
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.label = 'Remove All';
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.label = 'Remove Selected';
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.icon = "icon-ic_fluent_dismiss_circle_20_regular";
  }
  
  if (!$grid.inParams.allowEdit) {
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.disabled = true;
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.disabled = true;
      $grid.topToolbar.toggle_add_remove.hidden = true;
  }
  
  $grid.vars.hasBeenInitialized = true;
  }
  on_toggle_add_remove_materials_clicked(event = null) {
    return this.on_toggle_add_remove_materials_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_toggle_add_remove_materials_clickedInternal(
    $grid: FootprintManager_materials_selector_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_selector_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.toggle_add_remove.control.readOnly = true;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.readOnly = true;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = true;
  
  // Toggle between adding and removing materials
  $grid.inParams.isExclude = !$grid.inParams.isExclude;
  await $grid.refresh();
  await $grid.on_init();
  }
  on_add_remove_selected_materials_clicked(event = null) {
    return this.on_add_remove_selected_materials_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_add_remove_selected_materials_clickedInternal(
    $grid: FootprintManager_materials_selector_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_selector_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let selectedMaterialsChanged = false;
  $grid.topToolbar.toggle_add_remove.control.readOnly = true;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.readOnly = true;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = true;
  
  for (let row of $grid.selectedRows) {
      // If adding rows
      if ($grid.inParams.isExclude) {
          // If row doesn't already exist in outputs...
          if (!$grid.outParams.selectedMaterialIds.find(id => id === row.entity.Id)) {
              $grid.outParams.selectedMaterialIds.push(row.entity.Id);
              selectedMaterialsChanged = true;
          }
      }
      // If row is not selected...
      else {
          // If row exists in outputs...
          let index = $grid.outParams.selectedMaterialIds.indexOf(row.entity.Id);
          if (index >= 0) {
              $grid.outParams.selectedMaterialIds.splice(index, 1);
              selectedMaterialsChanged = true;
          }
      }
  }
  
  if (selectedMaterialsChanged) {
      $grid.topToolbar.toggle_add_remove.control.readOnly = true;
      await $grid.refresh();
      $grid.topToolbar.toggle_add_remove.control.readOnly = false;
  }
  }
  on_add_remove_all_materials_clicked(event = null) {
    return this.on_add_remove_all_materials_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_add_remove_all_materials_clickedInternal(
    $grid: FootprintManager_materials_selector_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_selector_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let selectedMaterialsChanged = false;
  let allMaterialIds = [];
  
  $grid.topToolbar.toggle_add_remove.control.readOnly = true;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = true;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.readOnly = true;
  
  if ($grid.inParams.isExclude) {
      // Collect all materialIds
      if ($grid.rows.length > 0) {
  
          let take = 5000;
          let skip = 0;
  
          do {
              let results = (await $datasources.InventoryCounts.ds_material_selector_grid.getList({
                  projectId: $grid.filters.project.control.value,
                  materialIds: $grid.outParams.selectedMaterialIds,
                  isExclude: $grid.inParams.isExclude,
                  storageCategoryRuleId: $grid.filters.storage_category_rules.control.value,
                  statusId: $grid.filters.status.control.value,
                  fullTextSearch: $grid.fullTextSearch,
                  $top: take,
                  $skip: skip
              }));
  
              skip += take;
              allMaterialIds = allMaterialIds.concat(results.result.map(r => r.Id));
  
          } while (skip > 0 && skip === allMaterialIds.length)
  
          if (allMaterialIds.length > 0) {
              $grid.outParams.selectedMaterialIds = $grid.outParams.selectedMaterialIds.concat(allMaterialIds);
              selectedMaterialsChanged = true;
          }
      }
  }
  else {
      $grid.outParams.selectedMaterialIds = [];
      selectedMaterialsChanged = true;
  }
  
  if (selectedMaterialsChanged) {
      await $grid.refresh();
  }
  
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_materials_selector_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_materials_selector_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.rows.length > 0) {
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = false;
  }
  else {
      $grid.topToolbar.add_dropdown.control.buttons.add_remove_all_materials.readOnly = true;
  }
  
  $grid.topToolbar.toggle_add_remove.control.readOnly = false;
  $grid.topToolbar.add_dropdown.control.buttons.add_remove_selected_materials.readOnly = true;
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
